export default __webpack_public_path__ + "static/media/betternull33.8549cdfe.jpg";